// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/store"
//重置样式
import "./global/resetPc.less"
//加载全局样式
import "./global/base.less"
import "./global/index.less"
import 'swiper/dist/css/swiper.css'
//载入雪碧图图标样式
import './global/sprite.css'
//载入jquery
import $ from "jquery"
//加载element-ui
import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import './router/permission'
// import "../theme/index.css"
//加载mockjs
// require("./mock")
import VCharts from 'v-charts'

Vue.use(VCharts)

Vue.use(Element)


Vue.config.productionTip = false
//全局过滤器
export const eventBus = new Vue()


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js